'use server'

import { apiRequest, ApiResponse } from '../request'

export interface Promotion {
    id: number
    name: string
    description?: string
    type: 'CATEGORY' | 'SUBCATEGORY' | 'MINIMUM_PURCHASE' | 'SPECIFIC_PRODUCTS'
    discountType: 'PERCENTAGE' | 'FIXED_AMOUNT'
    discountValue: number
    categoryId?: number
    category?: { id: number; name: string }
    subcategoryId?: number
    subcategory?: { id: number; name: string }
    minimumPurchase?: number
    products?: { id: number; catalogId: number; catalog: { id: number; name: string; media?: { url?: string | null }[] } }[]
    stores?: { id: number; storeConfigId: number; storeConfig: { id: number; name: string; subdomain: string; logo?: string } }[]
    startDate: string
    endDate: string
    active: boolean
    companyId: number
    createdAt: string
    updatedAt: string
}

export async function getPromotionsByCompany(
    companyId: number
): Promise<ApiResponse<Promotion[]>> {
    return apiRequest<Promotion[]>(`promos/company/${companyId}`, {})
}

export async function getPromotion(
    id: number
): Promise<ApiResponse<Promotion>> {
    return apiRequest<Promotion>(`promos/${id}`, {})
}

export async function createPromotion(
    data: Record<string, any>
): Promise<ApiResponse<Promotion>> {
    return apiRequest<Promotion>('promos', { data }, 'post')
}

export async function updatePromotion(
    id: number,
    data: Record<string, any>
): Promise<ApiResponse<Promotion>> {
    return apiRequest<Promotion>(`promos/${id}`, { data }, 'patch')
}

export async function deletePromotion(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`promos/${id}`, {}, 'delete')
}
